<template>
  <div id="load" v-if="getGlobaLoader()">
    <div id="load-inner"><div class="spinner-rotate"></div></div>
  </div>
  <!-- <div :class="{ globalActive: globalLoader }">
      <div class="fileList-loader global_loader" v-if="globalLoader || !isSiteStatusCalled">
			<div class="loader">
				<div class="sk-fading-circle">
					<div class="sk-circle1 sk-circle"></div>
					<div class="sk-circle2 sk-circle"></div>
					<div class="sk-circle3 sk-circle"></div>
					<div class="sk-circle4 sk-circle"></div>
					<div class="sk-circle5 sk-circle"></div>
					<div class="sk-circle6 sk-circle"></div>
					<div class="sk-circle7 sk-circle"></div>
					<div class="sk-circle8 sk-circle"></div>
					<div class="sk-circle9 sk-circle"></div>
					<div class="sk-circle10 sk-circle"></div>
					<div class="sk-circle11 sk-circle"></div>
					<div class="sk-circle12 sk-circle"></div>
				</div>
			</div>
		</div>

  </div> -->
  <template v-if="isSiteStatusCalled">
    <MobileSideMenu v-if="!underMaintenance"/>
  <header v-if="!underMaintenance && $route.name != 'NotFound'" class="" :class="!checkForHeaderShow() ? 'header-0px' : 'header-wapper header-search'" loading="lazy">
    <Header v-if="checkForHeaderShow()"/>
  </header>

  <section  :class="[ $route.name !== 'sports-event-detail' ? sectionClass : '', !checkForHeaderShow() ? 'pt-0' : '']" class="main-body-container-sec"
  :style="{ paddingTop: $auth.status ? '124px' : '90px' }">
    <div class="row g-0">
      <div class="col-0 col-sm-0 col-md-0 col-lg-2">
        <SideMenu v-if="!underMaintenance"/>
      </div>

      <div class="col-12 col-sm-12 col-md-12 col-lg-10">
        <div>
          <router-view v-if="$siteSettings?.data"/>
        </div>
      </div>
    </div>
  </section>  
  <template v-if="!underMaintenance">
    <Footer v-if="$route.name=='Home' || $route.name=='inplay'"/>
  </template>
  <template v-if="!$auth?.status">
    <Login/>
    <SignUp/>
    <ForgetPassword/>
  </template>
	<NotificationAlert @allowNotifications="allowNotifications" @cancelNotifications="cancelNotifications"/>


  <div v-if="successMsg" class="successfully-wrapper" style="z-index: 9999999999999999;"
    ref="successmodal" id="successfullyModal">
    <SuccessModal :message="successMsg" />
  </div>

  <div v-if="errorMsg" style="z-index: 9999999999999999;" class="successfully-wrapper"
    id="wrongtoaster">
    <ErrorModal :message="errorMsg" />
  </div>

  <LanguageSelection/>
  <Offers />

  <BonusInfoModal />
  <DownloadApkModal/>
  <CopyUserIdModal v-if="$auth.status" @open-offer="openOfferBanner()"/>
  <div class="demo-login-footer" v-if="$auth.status && this.$auth?.user?.isDemo && !$store.getters.globalLoader">
            <p>
                {{$t('this-is-demoid','This is Demo ID')}}
            </p>
    </div>
    <div class="demo-login-footer play-with-bonus-btn" v-if="$auth?.user?.actw == 'WB'">
        <p>
            {{ $t('playing-with-welcome-bonus', 'Playing with Welcome Bonus') }}
        </p>
    </div>
  </template>
    
  

  
</template>

<script>

import { defineAsyncComponent } from 'vue';
import { AUTH_TOKEN } from "./shared/constants/cookies-const";
import { setHeaders } from '@/shared/services/headers';
import axios from 'axios';
import socketService from "./socket/sport-socket-service";
import { mapGetters } from 'vuex';
import notificationAlert from '@/shared/services/notificationAlert';

export default {
  name: 'App',
  extends: notificationAlert,
  data() {
    return {
      onLine: navigator.onLine,
      showBackOnline: false,
      isSiteStatusCalled: false
    }
  },
  components: {
    NotificationAlert: defineAsyncComponent(() =>
      import('./shared/components/modal/NotificationAlert.vue')
    ),
    Header: defineAsyncComponent(() =>
      import('@/shared/components/header/Header.vue')
    ),
    MobileSideMenu: defineAsyncComponent(() =>
      import('@/shared/components/side-menu/MobileSideMenu.vue')
    ),
    SideMenu: defineAsyncComponent(() =>
      import('@/shared/components/side-menu/SideMenu.vue')
    ),
    Footer: defineAsyncComponent(() =>
      import('@/shared/components/footer/Footer.vue')
    ),
    Login: defineAsyncComponent(() =>
      import('@/modules/authorization/components/Login.vue')
    ),
    SignUp: defineAsyncComponent(() =>
      import('@/modules/authorization/components/SignUp.vue')
    ),
    ForgetPassword: defineAsyncComponent(() =>
      import('@/modules/authorization/components/ForgetPassword.vue')
    ),
    SuccessModal: defineAsyncComponent(() =>
      import('@/shared/components/modal/SuccessModal.vue')
    ),
    ErrorModal: defineAsyncComponent(() =>
      import('@/shared/components/modal/ErrorModal.vue')
    ),
    LanguageSelection: defineAsyncComponent(() =>
      import('./shared/components/header/LanguageSelection.vue')
    ),
    BonusInfoModal: defineAsyncComponent(() =>
      import('./shared/components/header/BonusInfoModal.vue')
    ),
    Offers: defineAsyncComponent(() =>
      import('./shared/components/header/Offers.vue')
    ),
    DownloadApkModal: defineAsyncComponent(() =>
      import('@/shared/components/modal/DownloadApkModal.vue')
    ),
    CopyUserIdModal: defineAsyncComponent(() =>
			import('./shared/components/modal/CopyUserIdModal.vue')
		),
  },
  computed:{
    ...mapGetters(['eventDetailHideSections', 'siteSettings', 'successMsg', 'errorMsg', 'siteVersion', 'underMaintenance']),
    routePath() {
			return this.$route.name
		},
    sectionClass() {
      if (!this.checkForHeaderShow()) {
        return 'padding-top-0';
      } else if (!this.$auth?.status) {
        if (!this.siteSettings?.announcement) {
          return 'padding-top-101';
        } else {
          return 'padding-top-105';
        }
      } else {
        if(this.$route.name == 'NotFound'){
          return 'padding-top-0';
        }
        if (!this.$siteSettings?.data?.announcement) {
          return this.$siteSettings?.data?.business_type==2 ? 'padding-top-150' : 'padding-top-101';
        } else {
          return this.$siteSettings?.data?.business_type==2 ? 'padding-top-170' : 'padding-top-105';
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch('setGlobalLoader', true);
    //for use on js pages
    this.getSiteVersion();
    window.store = this.$store;
    window.cookies = this.$cookies;
    window.router = this.$router;
    window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
    setHeaders();
    this.$errorToast(null);
		this.$successToast(null);
    if(this.$auth?.status) {
      if(this.$store.getters.stateUser.notificationUnsubscribed==1){
				return;
			}
			if(this.$store.getters.stateUser.notificationSubscribed!=1) {
				this.requestNotificationPermission()
			}
    }
  
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    this.socketAllEvents();
    this.$store.dispatch('setDefaultPhoneIndexFromSettings');
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  methods: {
    async getSiteVersion() {
			this.$store.dispatch('setGlobalLoader', true);
			this.$apiCall('get', 'GET_SITE_VERSION', null, 'user', { domain: window.location.hostname }).then(async response => {
				if (response && response.status == 200) {
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
						let resData = response?.data?.data;
						let currentVersion = resData.version;
						let userSystemVersion = this.siteVersion || 0;		
						if (!userSystemVersion || currentVersion != userSystemVersion || !this.$siteSettings.data) {
							this.$store.dispatch('setSiteVersion', currentVersion);
							this.getSiteSettingsServiceCall();
						} else {
							this.siteSettingCommon(this.$siteSettings.data);
						}
						if (resData.maintenance) {
							const { from_date, to_date } = resData.maintenance;
							const fromDateTime = new Date(from_date).getTime();
							const toDateTime = new Date(to_date).getTime();
							const currentDateTime = Date.now();

							const isInMaintenanceWindow = fromDateTime <= currentDateTime && currentDateTime <= toDateTime;

							if (fromDateTime && toDateTime && isInMaintenanceWindow) {
								this.$store.dispatch('setUnderMaintenance', resData.maintenance);
								this.$router.push({ name: 'Maintenance' });
							}
						}
						else {
							if(this.underMaintenance) {
								this.$router.push({name:'Home'});
							}
							this.$store.dispatch('setUnderMaintenance', null); 
						}
						this.$store.dispatch('setGlobalLoader', false);
            this.isSiteStatusCalled = true
					}
				}
			}).catch(error => {
				if (error) {
					this.$store.dispatch('setGlobalLoader', false);
					this.$errorToast(error[0]);
				}
			});
		},
    checkForHeaderShow() {
			 if (this.eventDetailHideSections && this.eventDetailHideSections.includes('show_full_screen') && this.routePath == 'sports-event-detail') {
				return false;
			} else {
				return true;
			}
		},
    getGlobaLoader() {
			return this.$store.getters.globalLoader;
		},
    async getSiteSettingsServiceCall() {
      this.$store.dispatch('setGlobalLoader', true);
			this.$apiCall('get', 'GET_SITE_SETTINGS', null, 'user', { domain: window.location.hostname }).then(async response => {
        this.$store.dispatch('setGlobalLoader', false);
        if (response) {
          if (response.status == 200) {
            if (response?.data?.status == 0) {
              this.$errorToast(response.data.debug[0]);
            }
            else {
              let resData = response?.data.data;
              resData.siteSetting.announcement = JSON.parse(resData.siteSetting.announcement);
              resData.siteSetting.offer = resData.siteSetting.poster.find(pos => pos.poster_type == 12);
              let casino;
              if(resData?.casino_url) {
                const getCasinoGame = async () => {
                let casinoUrl = resData.casino_url.includes(resData.siteSetting.aws_url) ?  resData.casino_url : `${resData.siteSetting.aws_url}/${resData.casino_url}`;
								let gameResp = await axios.get(casinoUrl)
								return gameResp.data
                };
                casino = await getCasinoGame();
              } else {
                casino = resData?.casino_url
              }
              const { sub_domains, url } = resData.siteSetting;
                const parentSiteDomain = [];
                const otherSiteDomain = [];

                for (const item of sub_domains) {
                    (item.url === url ? parentSiteDomain : otherSiteDomain).push(item);
              }
              resData.siteSetting.sub_domains = [...otherSiteDomain, ...parentSiteDomain];
              this.$store.dispatch('setSettings', resData.siteSetting);
              this.$store.dispatch('setGamesData', casino);
              this.$store.dispatch('setBonusData', resData.bonus_data);
              this.siteSettingCommon(resData.siteSetting);	
            }
          }
        }
      }).catch(error => {
        this.$store.dispatch('setGlobalLoader', false);
        if (error) {
          this.$errorToast(error[0]);
        }
      });
    },
    openOfferBanner(){
        this.$helper.openModal('#offer_pop_up')
    },

    async siteSettingCommon(siteSetting) {
			try {        
				if (siteSetting.languagesList) {
					this.$setCurrentLangData(siteSetting.languagesList, siteSetting.language_code, siteSetting.aws_url)
					this.$store.dispatch('setLanguagesData', siteSetting.languagesList);
				}
				this.setManifest(siteSetting);
        if(siteSetting?.meta_pixel_code) {
            this.addFacebookPixel(siteSetting?.meta_pixel_code);
          }
          // Create FAVICON
          const favElement = document.createElement('link');
          favElement.rel = 'icon';
          favElement.href = siteSetting.aws_url + siteSetting.storage_path.domain_image + siteSetting.fav_logo;
          document.head.insertAdjacentElement('beforeend', favElement);
          const title = document.getElementById("title");
          title.text = siteSetting?.site_title ? siteSetting?.site_title : siteSetting?.domain_name;
          let is_offer = localStorage.getItem("is_offer");
          if(siteSetting.meta_tags) {
					document.head.innerHTML += siteSetting.meta_tags;
				};
        if(siteSetting.g_tags) {
					this.setGoogleAnalyticsTag(siteSetting.g_tags);
				};
        if(siteSetting.site_map) {
					const sitemapLink = document.createElement("link");
					sitemapLink.rel = "sitemap";
					sitemapLink.type = "application/xml";
					sitemapLink.title = "Sitemap";
					sitemapLink.href = siteSetting.aws_url + siteSetting.storage_path.site_map + siteSetting.site_map;
					document.head.appendChild(sitemapLink);
				};
        try {
					if (siteSetting.front_css != null && siteSetting.front_css != '') {
						const styleElement = document.createElement('style');
						styleElement.type = 'text/css';
						styleElement.appendChild(document.createTextNode(siteSetting.front_css));
						document.head.insertAdjacentElement('beforeend', styleElement);
					}
				} catch (error) {
          console.log("ERROR 1: ", error);
          }
          if (this.$auth?.status){
            this.getFavourites()
            this.getWalletBalance();
            setTimeout(() => {
              let userIdList = this.$store.getters.userIdList;
              let login_type = localStorage.getItem('UserIdorLogin')
              if (this.$auth?.status && siteSetting.offer != null && is_offer == null && this.$siteSettings?.data?.business_type == 2 && this.$auth.user.last_login_at) {
                  this.openOfferBanner();
              }
          }, 500);
          }
				} catch (error) {          
					this.$errorToast(error);
				}
		},
    setGoogleAnalyticsTag(gTag) {
				let script1 = document.createElement('script');
				script1.async = true;
				script1.src = `https://www.googletagmanager.com/gtag/js?id=${gTag}`;
	
				let script2 = document.createElement('script');
				script2.innerHTML = `
					window.dataLayer = window.dataLayer || [];
					function gtag(){dataLayer.push(arguments);}
					gtag('js', new Date());
					gtag('config', '${gTag}');
				`;
	
				document.head.appendChild(script1);
				document.head.appendChild(script2);
			},
    setManifest(resData) {
			let manifestName = resData.domain_name.charAt(0).toUpperCase() + resData.domain_name.slice(1).toLowerCase();
			var dynamicManifest = {
				name: manifestName,
				short_name: manifestName,
				start_url: window.location.origin,
				display: 'standalone',
				icons: [{
					src: resData.app_logo ? resData.aws_url + resData.storage_path.domain_image + resData.app_logo : resData.aws_url + resData.storage_path.domain_image + resData.fav_logo,
					sizes: "256x256 512x512 192x192 144x144",
					type: "image/png",
					purpose: 'any'
				}]
			}
			
			// Manifest Blob
			const stringManifest = JSON.stringify(dynamicManifest);
			const blob = new Blob([stringManifest], { type: 'application/json' });
			const manifestURL = URL.createObjectURL(blob);
			
			// Manifest Creation
			const favElement = document.createElement('link');
			favElement.rel = 'manifest';
			favElement.href = manifestURL;
			document.head.insertAdjacentElement('beforeend', favElement);
			
			// IOS APK Logo
			let logo = resData.aws_url + resData.storage_path.domain_image + resData.logo;
			document.querySelector('#appleIcon').setAttribute('href', logo);
			document.querySelector('#appleLaunchIcon').setAttribute('href', logo);

			// IOS App title
			const metaTag = document.createElement('meta');
			metaTag.setAttribute('name', 'apple-mobile-web-app-title');
			metaTag.setAttribute('content', manifestName);
			document.head.insertAdjacentElement('beforeend', metaTag);
		},
    getWalletBalance() {
      let authToken = this.$cookies.get(AUTH_TOKEN);
      if (!authToken) return;
			this.$apiCall('post', 'WALLET_BALANCE').then(response => {
        if (response && response.status == 200 && response.data) {
          let user = this.$store.getters.stateUser;
          user.balance = response.data.bl;
          user.exposure = response.data.ex;
          user.bets_count = response.data.bc;
          user.earnBonus = response.data.eb;
          this.$store.dispatch('setUser', user);
            setTimeout(function () {
              this.getWalletBalance();
            }.bind(this), 2000);
          // }
        } else {
          this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
          this.$store.dispatch('resetAllState');
        }
      }).catch(error => {
        if (error) {
          this.$errorToast(error[0]);
        }
      });
    },
    refreshAuthToken() {
      this.refreshInit = true;
			this.$apiCall('post', 'AUTH_REFRESH').then(response => {
        let user = this.$store.getters.stateUser;
        user.token = response.data.data.token;
        user.exp = response.data.data.exp;
        this.$cookies.set(AUTH_TOKEN, response.data.data.token);
        this.$store.dispatch('setToken', `Bearer ${response.data.data.token}`);
        window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
        //for add on all APIs
        axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
        this.$store.dispatch('setUser', user);
        this.refreshInit = false;
        setTimeout(function () {
          this.getWalletBalance();
        }.bind(this), 2000);
      }).catch(error => {
        if (error) {
          this.$errorToast(error[0]);
        }
        this.refreshInit = false;
      });
    },
    updateOnlineStatus(e) {
      const {
        type
      } = e;
      this.onLine = type === 'online';
    },
    socketAllEvents() {
      if (this.$store.getters.stateUser) {
        socketService.emit("sub", 'depositRequest-' + this.$store.getters.stateUser.userid);
        socketService.emit("sub", 'logout-' + this.$store.getters.stateUser.userid);
        socketService.emit("sub", 'banned-' + this.$store.getters.stateUser.userid);

        socketService.on("DepositRequest", (data) => {
          if (data.type == "myId") {
            if (data.notify_type == 1) {
              this.$store.dispatch('setNotification');
              this.$successToast('New Notification...')
            }
          }
        });
        socketService.on("logout", (data) => {
          if (data.type == "logout") {
            // logout user from users
            // if (data.notify_type == 1) {
            // 	this.$store.dispatch('setNotification');
            // 	this.$successToast('New Notification...')
            // }
          }
        });
        socketService.on("banned", (data) => {
          if (data.type == "match_ban") {
            // match ban condition
          } else if (data.type == 'league_ban') {
            // league ban condition
          }
        });

      }
    },
		getFavourites() {
			let data = {
				"game_type": 1
			}
			this.$apiCall('post', 'GET_FAVOURITE_LIST', data).then(response => {
				if (response) {
					if (response.status == 200) {
						if (response?.data?.status != 0) {
							var allData = response.data.events;
							var ids = [];
							for (var i = 0; i < allData.length; i++) {
								ids.push(allData[i])
							}
							this.$store.dispatch('setFavouriteGames', ids)
						}
					}
				}
			}).catch(error => {
				if (error) {
          this.$errorToast(error)
				}
			});
		},
    addFacebookPixel(pixelId) {
			const script = document.createElement('script');
			script.innerHTML = `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '${pixelId}');
				fbq('track', 'PageView');
			`;
			document.head.appendChild(script);

			// Add the noscript image
			const noscript = document.createElement('noscript');
			noscript.innerHTML = `
				<img height="1" width="1" style="display:none"
					src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>
			`;
			document.head.appendChild(noscript);
		},
  },
  watch: {
    onLine(v) {
      if (v) {
        this.showBackOnline = true;
        setTimeout(() => {
          this.showBackOnline = false;
        }, 1000);
      }
    }
  }
}
</script>
